"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPStorybookAPIClient = void 0;
const utils_1 = require("../utils");
const kendo_react_common_1 = require("@progress/kendo-react-common");
const axios_1 = __importDefault(require("axios"));
const storybookAxiosConfig = () => {
    const config = {
        APIKey: process.env.STORYBOOK_SP_API_KEY || "",
        SK: process.env.STORYBOOK_SP_API_SECRET_KEY || "",
        SPAPIURL: ""
    };
    return {
        baseURL: `${config.SPAPIURL}/api`,
        headers: {
            APIKey: config.APIKey || null,
            SK: config.SK || null
        }
    };
};
const transformOData = (config) => {
    if (!config.params) {
        return config;
    }
    const selects = config.params["$select"] || config.params["select"] || undefined;
    config.params["$select"] =
        (selects && selects.join && selects.join(",")) || undefined;
    delete config.params["select"];
    const expands = config.params["$expand"] ||
        config.params["expand"] ||
        utils_1.getExpandsFromSelects(selects) ||
        [];
    config.params["$expand"] =
        (expands && expands.join && expands.join(",")) || undefined;
    delete config.params["expand"];
    if (config.params["top"]) {
        config.params["$top"] = config.params["top"];
        delete config.params["top"];
    }
    if (config.params["skip"]) {
        config.params["$skip"] = config.params["skip"];
        delete config.params["skip"];
    }
    if (config.params["filter"]) {
        config.params["$filter"] = config.params["filter"];
        delete config.params["filter"];
    }
    return config;
};
exports.SPStorybookAPIClient = axios_1.default.create(storybookAxiosConfig());
exports.SPStorybookAPIClient.interceptors.request.use(transformOData);
exports.SPStorybookAPIClient.interceptors.request.use(config => {
    config.headers["Correlation-Id"] = kendo_react_common_1.guid();
    return config;
});
const handleResponse = (response) => response;
const handleError = (error) => Promise.reject(error.response ? error.response : error);
exports.SPStorybookAPIClient.interceptors.response.use(handleResponse, handleError);
//# sourceMappingURL=SPStorybookAPIClient.js.map